export function convertBase64(file) {
  if (!file || !(file instanceof Blob)) {
    return null;
  }
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}

export function validateImageType(file) {
  return file.type.split("/")[0] === "image";
}

export function arrayBufferToFile(arrayBuffer, type, fileName) {
  const blob = new Blob([arrayBuffer], { type });
  return new File([blob], fileName, { type });
}

export function arrayBufferToUrl(arrayBuffer, contentType) {
  const blob = new Blob([arrayBuffer], { type: contentType });
  return URL.createObjectURL(blob);
}

export function arrayBufferToDownloadFile(arrayBuffer, type, fileName) {
  let a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  const blob = new Blob([arrayBuffer], { type });
  const url = URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
